import React from "react";
import {
  Award,
  Code,
  Users,
  FileText,
  ShieldCheck,
  Clock,
  Briefcase,
} from "lucide-react";

const Internship = () => {
  return (
    <section
      id="internship"
      style={{
        background: "var(--bg-primary)",
        padding: "100px 7.6923%",
        borderTop: "1px solid var(--border-subtle)",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2 className="display-large" style={{ marginBottom: "20px" }}>
            Internship Pathway with Ciqur24
          </h2>
          <p
            className="body-large"
            style={{
              color: "var(--text-secondary)",
              maxWidth: "900px",
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            Ciqura Labs is the training division of{" "}
            <strong style={{ color: "var(--brand-primary)" }}>Ciqur24</strong>.
            Top selected students work on real client projects inside a 
            cybersecurity company.
          </p>
        </div>

        {/* Pathway Flow */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "40px",
            marginBottom: "70px",
          }}
        >
          <div className="dark-hover" style={cardStyle}>
            <ShieldCheck size={42} style={iconStyle} />
            <h3 className="heading-2">Selection Criteria</h3>
            <p className="body-medium" style={textStyle}>
              Internships are offered to students who successfully complete the
              training program, labs, and internal assessments.
            </p>
            <ul style={listStyle}>
              <li>✔ Minimum lab & attendance score</li>
              <li>✔ Technical evaluation</li>
              <li>✔ Interview readiness check</li>
            </ul>
          </div>

          <div className="dark-hover" style={cardStyle}>
            <Clock size={42} style={iconStyle} />
            <h3 className="heading-2">Duration & Structure</h3>
            <p className="body-medium" style={textStyle}>
              Structured internship designed to simulate real corporate
              workflows.
            </p>
            <ul style={listStyle}>
              <li>✔ Duration: 8–12 weeks</li>
              <li>✔ Part-time / Full-time options</li>
              <li>✔ Weekly mentor reviews</li>
            </ul>
          </div>

          <div className="dark-hover" style={cardStyle}>
            <Briefcase size={42} style={iconStyle} />
            <h3 className="heading-2">Real Client Projects</h3>
            <p className="body-medium" style={textStyle}>
              Interns work on live cybersecurity, SOC, VAPT, cloud security, and
              IT operations & web development projects handled by Ciqur24.
            </p>
            <ul style={listStyle}>
              <li>✔ SOC monitoring & alerts</li>
              <li>✔ Vulnerability assessments</li>
              <li>✔ Cloud & endpoint security tasks</li>
<li>✔ Full stack develeopment</li>
            </ul>
          </div>

          <div className="dark-hover" style={cardStyle}>
            <Award size={42} style={iconStyle} />
            <h3 className="heading-2">Certificate & Career Support</h3>
            <p className="body-medium" style={textStyle}>
              Successful interns receive an industry-recognized internship
              certificate and career guidance.
            </p>
            <ul style={listStyle}>
              <li>✔ Internship completion certificate</li>
              <li>✔ Resume & LinkedIn review</li>
              <li>✔ Placement & referral support*</li>
            </ul>
          </div>
        </div>

        {/* Footer Note */}
        <div
          style={{
            background: "rgba(0,255,209,0.08)",
            border: "1px solid var(--brand-primary)",
            padding: "36px",
            textAlign: "center",
          }}
        >
          <p className="body-large" style={{ color: "var(--text-primary)" }}>
            🚀 This internship pathway bridges{" "}
            <strong>training → real work → employability</strong>, helping
            students gain the confidence and experience required for SOC
            Analyst, Cybersecurity Engineer, Cloud Admin, and IT Operations
            roles.
          </p>
        </div>
      </div>
    </section>
  );
};

/* Reusable Styles */
const cardStyle = {
  background: "var(--bg-secondary)",
  padding: "40px",
  border: "1px solid var(--border-subtle)",
  textAlign: "left",
  transition: "all 0.4s ease-in-out",
  position: "relative",
};

const iconStyle = {
  color: "var(--brand-primary)",
  marginBottom: "18px",
};

const textStyle = {
  color: "var(--text-secondary)",
  marginBottom: "16px",
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  color: "var(--text-secondary)",
  lineHeight: 1.7,
};

export default Internship;
